export enum ModalName {
  FeatureRestricted = 'featureRestricted',
}
